import React from "react";
import axiosInstance from "@/config/axiosInstance";
import { getCMSApiRoute } from "../api.util";

export function useCountryList() {
  const [items, setItems] = React.useState([]);
  const [hasMore, setHasMore] = React.useState(true);
  const [isLoading, setIsLoading] = React.useState(false);
  const [offset, setOffset] = React.useState(0);
  const limit = 10; // Number of items per page, adjust as necessary

  const loadCountry = async () => {
    const controller = new AbortController();
    const { signal } = controller;

    try {
      setIsLoading(true);

      const response = await axiosInstance.get(
        getCMSApiRoute("content/global-variables"),
        {
          signal,
        }
      );

      if (!response.statusText === "ok") {
        throw new Error("Network response was not ok");
      }

      const { data } = response.data;
      const countries = data.Countries;

      setHasMore(false);
      const countriesArray = Object.keys(countries).map((key) => {
        return {
          id: key,
          key: countries[key],
          label: countries[key],
        };
      });
      setItems(countriesArray);
    } catch (error) {
      console.log(error);
      if (error.name === "AbortError") {
        console.log("Fetch aborted");
      } else {
        console.error("There was an error with the fetch operation:", error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    loadCountry(offset);
  }, []);

  const onLoadMore = () => {
    const newOffset = offset + limit;

    setOffset(newOffset);
    loadCountry(newOffset);
  };

  return {
    items,
    hasMore,
    isLoading,
    onLoadMore,
  };
}
